import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, Modal, Form } from 'antd';
import styled from 'styled-components';
import { inputTypeComponent, showHideInput, getInputData } from "../helper";
import { ModalHeader } from "datastake-daf/dist/components";

const Styles = styled.div`
	width: 100%;
`;

function LinkingModal({
  authentication: { user },
  props = {},
  formsValue = {},
  mainForm,
  name = null,
  inputName = null,
  content = null,
  onChange = () => { },
  onOptions = () => { }
}) {
  const [MainForm] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const language = localStorage.getItem('datastakeLng');

  return <Styles>
    <Modal
      title={(
        <ModalHeader
          title="Link Stakeholder"
        />
      )}
      open={modalVisible}
      footer={false}>
      <Form form={MainForm} key="test">
        {content && Object.keys(content).map(input => {
          const config = getInputData(input, content[input], null, null, input, {});
          return showHideInput(content[input], {}, input, {}, () => { }, input) ?
            <Form.Item
              name={input}
              label={content[input].label[language]}>
              {inputTypeComponent[content[input].inputType](config, {
                form: MainForm,
                setFormValues: () => { },
              })}
            </Form.Item>
            : null
        })}
      </Form>
    </Modal>
    <Button onClick={() => setModalVisible(!modalVisible)}>Click</Button>
  </Styles>
}

const mstp = ({ authentication }) => ({ authentication });

export default connect(mstp)(LinkingModal);
